import React from "react";
import TimePicker, { TimePickerValue } from "react-time-picker";
import { formatTime24h } from "../common/timeFormat";

interface TimeSpanPickerProps {
    children?: React.ReactNode;
    dir?: string;
    start_time: number | null | undefined;
    end_time: number | null | undefined;
    onStartTimeChange:any;
    onEndTimeChange:any;
}
function TimeSpanPicker( props: TimeSpanPickerProps) {
    const { children, start_time,end_time, onStartTimeChange,onEndTimeChange,...other } = props;

    const onTimeStartChange = (pickedTime: TimePickerValue) => {
        //console.log("start time:", pickedTime);
        if(pickedTime){
          onStartTimeChange(Date.parse(`1970-01-01T${pickedTime}:00+0000`) / 1000);
            //const t = pickedTime?hours() * 3600 + pickedTime?.minute() * 60;
        }else{
          onStartTimeChange(0);
        }
    };
    const onTimeEndChange = (pickedTime: TimePickerValue) => {
        //console.log("end time:", pickedTime);
        if(pickedTime){
          onEndTimeChange(Date.parse(`1970-01-01T${pickedTime}:00+0000`) / 1000);
            //const t = pickedTime?hours() * 3600 + pickedTime?.minute() * 60;
        }else{
          onEndTimeChange(0);
        }
    };
    return (
    <span {...other}>
          <TimePicker disableClock clearIcon={null} locale="en-US"
              value={ formatTime24h(start_time, "00:00") }
              format="HH:mm"
              hourAriaLabel="Hour" minuteAriaLabel="Minute" onChange={onTimeStartChange} />
          <span className="time-span-sep">〜</span>
          <TimePicker disableClock clearIcon={null} locale="en-US"
              value={ formatTime24h(end_time, "00:00") }
              format="HH:mm"
              hourAriaLabel="Hour" minuteAriaLabel="Minute" onChange={onTimeEndChange} />
    </span>
    );
}
export type { TimeSpanPickerProps };
export { TimeSpanPicker };
export default TimeSpanPicker;
